export default {
  title: 'Modeltraining',
  subtitle: 'Twórz nowe modele uczenia maszynowego, aby przewidywać działanie czujników na podstawie innych dostępnych czujników',
  saveAction: 'model pociągu',
  selectTargetHeadline: 'Sygnał docelowy',
  selectFeaturesHeadline: 'Sygnały funkcji',
  selectTrainingData: 'Dane treningowe',
  configureModel: 'Konfiguracja modelu',
  modelDisplayName: 'Nazwa modelu',
};
